import React, { Component, PropsWithChildren, ReactNode } from 'react';
import intl from 'react-intl-universal';
import TopError from './TopError';
import LayoutError from './LayoutError';
import ComponentError from './ComponentError';

export interface ErrorBoundaryProps extends PropsWithChildren {
  errorType?: 'top' | 'layout' | 'component';
  errorText?: string;
  fallback?: string | ReactNode;
}
export interface ErrorBoundaryState {
  hasError?: boolean;
  error?: Error & { code: number; data: any; msg: string; }
}
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    // console.log('error bundary constructor', props);
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // console.log('error bundary getDerivedStateFromError', error.message);
    // 更新 state，下一次渲染将展示备选 UI。
    return { hasError: true, error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // 可以做错误上报处理
    console.log('error bundary componentDidCatch', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      if (this.props.errorType === 'top') return <TopError error={this.state.error} errorText={this.props.errorText} />;
      if (this.props.errorType === 'layout') return <LayoutError error={this.state.error} errorText={this.props.errorText} />;
      if (this.props.errorType === 'component') return <ComponentError error={this.state.error} errorText={this.props.errorText} />;
      return <ComponentError error={this.state.error} errorText={intl.get('ERROR_COMPONENT_DEFAULT_TEXT')} />;
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
export { TopError, LayoutError, ComponentError };